import { css, jsx } from '@emotion/core';
import Router from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';

import ContactInitials from '@/src/shared/components/ContactCard/ContactInitials';
import Sanitize from '@/src/shared/components/Sanitize';
import { bp, colors } from '@/styles';

const style = {
  container: css`
    padding: 8px;
    border-radius: 2px;
    background-color: #ffffff;
    box-shadow: 0 6px 12px 0 rgba(35, 32, 32, 0.1);
    width: 100%;
    display: flex;
    margin-bottom: 16px;
    @media ${bp.lg} {
      width: 468px;
      margin: 10px;
    }
  `,
  title: css`
    font-weight: 700;
    margin-bottom: 0;
  `,
  image: css`
    border-radius: 50%;
    width: 75px;
    height: 75px;
    object-fit: cover;
    object-position: center;
  `,
  inner: css`
    display: flex;
    flex-direction: column;
  `,
  name: css`
    color: ${colors.secondaryBlue};
    font-size: 1.6rem;
    line-height: 2.8rem;
    font-weight: bold;
  `,
  infoContainer: css`
    margin-left: 12px;
    display: flex;
    flex-direction: column;
  `,
  link: css`
    color: ${colors.secondaryBlue};
    font-weight: bold;
  `,
  info: css`
    color: ${colors.secondaryGray};
    font-size: 1.4rem;
  `,
  titleInfo: css`
    color: ${colors.secondaryGray};
    font-size: 1.4rem;
    font-weight: bold;
    margin-bottom: 3px;
  `,
  contactUs: css`
    font-weight: 800;
    color: ${colors.secondaryBlue};
  `,
};
const memberClick = (id, route) => {
  const url = `${route}/${id}`;
  Router.push(url, url);
};
const MemberTile = ({ member, route, enableBio, showPosition }) => {
  const {
    EmailAddress,
    FullName,
    Position,
    PersonId,
    Phone,
    Picture,
    Initials,
    Title,
    CompanyId,
    CompanyName,
    Extra,
  } = member;
  const fullName = showPosition ? `${FullName} &mdash; ${Position}` : FullName;
  return (
    <div css={style.container}>
      {Picture ? (
        <img
          src={`data:image/jpeg;base64,${Picture}`}
          alt={`${FullName} Profile`}
          css={style.image}
        />
      ) : (
        <ContactInitials icon="user" initials={Initials} />
      )}
      <div css={style.infoContainer}>
        {enableBio ? (
          <>
            <a css={style.name} onClick={() => memberClick(PersonId, route)}>
              <Sanitize>{fullName}</Sanitize>
            </a>
          </>
        ) : (
          <>
            <strong>
              <Sanitize>{fullName}</Sanitize>
            </strong>
          </>
        )}
        <div css={style.titleInfo}>
          <Sanitize>{Title}</Sanitize>
        </div>
        <div css={style.titleInfo}>
          <Sanitize>{CompanyName}</Sanitize>
        </div>
        {CompanyId === '4274' ? (
          <>
            <a css={style.info} href={`tel:${Phone}`}>
              {Phone}
            </a>
            <a css={style.link} href={`mailto:${EmailAddress}`}>
              {EmailAddress}
            </a>
          </>
        ) : null}
        {Extra && <Sanitize>{Extra}</Sanitize>}
      </div>
    </div>
  );
};

MemberTile.propTypes = {
  member: PropTypes.object.isRequired,
};

export default MemberTile;
